import { Coupon } from './coupon.model';

export class CouponResolution extends Coupon {
  bestCouponName?: string;
  bestCouponCode?: string;
}
